import { ValidateBookingRulesInput } from "./hooks/useValidateBookingRules/__generated__/useValidateBookingRulesMutation.graphql";

export { useRestrictionDisplayName } from "./hooks/useRestrictionDisplayName";
export { useValidateBookingRules } from "./hooks/useValidateBookingRules";
export {
  normalizeBookingRule,
  normalizeBookingRules,
} from "./utils/normalizeBookingRule";

export interface ValidateBookingRestructionsInputType
  extends ValidateBookingRulesInput {}
